module.exports = __webpack_public_path__ + "staticcomp/img/cover.cbee088.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/9/cover.jpg
// module id = zf27
// module chunks = 39